module.exports = __webpack_public_path__ + "img/multi_terminal.b5b9a88e.png";